import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'postcodes',
            name: 'postcode',
            class: 'Modules\\Address\\Entities\\Postcode'
        }
    }
}